var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTuitorialsBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 279,
    viewBox: "0 0 1440 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1302.85 19.5107C1180.26 -23.6902 1079.4 16.8838 951.517 26.8961C823.64 36.9084 831.342 24.2827 736.066 14.4991C640.791 4.71551 586.58 56.463 541 66.8981V184H1449L1438.33 60.0908C1438.33 60.0908 1425.66 62.7907 1302.85 19.5107Z",
    fill: "url(#paint0_linear_76_166)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M247 97.9752C322.25 21.3754 385.262 25.9578 427.231 32.0393C469.201 38.1208 536.156 81.3779 623.184 72.1911C710.211 63.0044 884 165 884 165H247V97.9752Z",
    fill: "url(#paint1_linear_76_166)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-116 137.754C107.853 -86.3854 220.06 54.1789 368.69 82.6735C517.32 111.168 538.469 153.569 637.167 145.389C735.862 137.209 1217 279 1217 279H-116V137.754Z",
    fill: "url(#paint2_linear_76_166)",
    fillOpacity: 0.57
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_166",
    x1: 999.913,
    y1: -46.4624,
    x2: 980.83,
    y2: 117.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61D2CC",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_76_166",
    x1: 565.499,
    y1: 52.1352,
    x2: 565.499,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176AB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD8F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_76_166",
    x1: -25.5978,
    y1: -37.5854,
    x2: -25.5978,
    y2: 249.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF927A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F8F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuitorialsBackground);
export default __webpack_public_path__ + "static/media/tuitorialsBackground.d3b2c3f513e76b9815c2b6ec42d91fda.svg";
export { ForwardRef as ReactComponent };